import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import { HeroShaped } from 'components/organisms';
import { Link } from 'gatsby';

const useStyles = makeStyles(theme => ({
  root: {
    // background:
    //   'url(https://assets.maccarianagency.com/the-front/illustrations/patterns-bg.svg) no-repeat left bottom',
    backgroundSize: 'contain',
    backgroundColor: theme.palette.alternate.main,
  },
  cover: {
    position: 'relative',
    zIndex: 9,
    width: '100%',
    height: '100%',
  },
  image: {
    objectFit: 'cover',
  },
  link: {
    color: 'inherit',
  },
}));

const Hero = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <HeroShaped
        leftSide={
          <SectionHeader
            title="Chartered Professional Accountants"
            subtitle="At Helen Ge CPA, our professional tax and accounting services are tailored to you. We measure our success by yours. Let's talk about how we can best meet your needs!"
            subtitleColor="textPrimary"
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                <Link className={classes.link} to="/contact-page">
                  Contact Us
                </Link>
              </Button>,
            ]}
            align="left"
            data-aos="fade-up"
            titleVariant="h3"
          />
        }
        rightSide={
          <div className={classes.cover}>
            <Image
              src={require('assets/images/home-sm.jpg')}
              srcSet={require('assets/images/home-lg.jpg')}
              className={classes.image}
              lazyProps={{
                width: '100%',
                height: '100%',
              }}
            />
          </div>
        }
      />
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
